import { AccessorsMutatorsDecorator, Model } from "../../helpers";
import { Property } from "./property.model";
import { BillingInformation } from "./billing-information.model";
import { PaymentDetail } from "./payment-detail.model";
import { AddonSetting } from "./addon-setting.model";
import { Coupon } from "./coupon.model";

/**
 * @class Subscription
 *
 */
export class Subscription extends Model {

    static get TYPE_LIVE() {

        return 1;
    }

    static get TYPE_TRIAL() {

        return 2;
    }

    static get RECURRING_PLAN_MONTHLY() {

        return 1;
    }

    static get RECURRING_PLAN_ANNUAL() {

        return 2;
    }

    static get STATUS_CANCELLED() {

        return 1;
    }

    static get STATUS_EXPIRED() {

        return 2;
    }

    static get STATUS_FUTURE() {

        return 3;
    }

    static get STATUS_LIVE() {

        return 4;
    }

    static get STATUS_NON_RENEWING() {

        return 5;
    }

    static get STATUS_SUSPENDED() {

        return 6;
    }

    static get STATUS_TRIAL() {

        return 7;
    }

    static get STATUS_TRIAL_EXPIRED() {

        return 8;
    }

    static get STATUS_UNPAID() {

        return 9;
    }

    static get FORMATTED_STATUSES() {

        return {
            [this.STATUS_FUTURE]: 'FUTURE',
            [this.STATUS_UNPAID]: 'UNPAID',
            [this.STATUS_EXPIRED]: 'EXPIRED',
            [this.STATUS_LIVE]: 'LIVE',
            [this.STATUS_TRIAL]: 'TRIAL',
            [this.STATUS_CANCELLED]: 'CANCELED',
            [this.STATUS_TRIAL_EXPIRED]: 'TRIAL_EXPIRED',
            [this.STATUS_SUSPENDED]: 'SUSPENDED',
            [this.STATUS_NON_RENEWING]: 'NON_RENEWING',
        };
    }

    static get validationModel() {

        return {
            trial_days: {
                label: 'TRIAL_DAYS',
                messages: {
                    notLessThan: 'THE_ENTERED_VALUE_SHOULD_BE_GREATER_THAN_O'
                }
            }
        };
    }

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        if (!value) {

            return value;
        }

        return value instanceof Property ? value : new Property(value);
    }

    /**
     * @param {Object|BillingInformation} value
     * @returns {BillingInformation}
     */
    setBillingInformation(value) {

        if (!value) {

            return value;
        }

        return value instanceof BillingInformation ? value : new BillingInformation(value);
    }

    /**
     * @param {Object|Coupon} value
     * @returns {Coupon}
     */
    setCoupon(value) {

        if (!value) {

            return value;
        }

        return value instanceof Coupon ? value : new Coupon(value);
    }

    /**
     * @param {Object|PaymentDetail} value
     * @returns {PaymentDetail}
     */
    setPaymentDetail(value) {

        if (!value) {

            return value;
        }

        return value instanceof PaymentDetail ? value : new PaymentDetail(value);
    }

    /**
     * @param {Object[]|AddonSetting[]} value
     * @returns {AddonSetting[]}
     */
    setAddons(value) {

        if (!value) {

            return value;
        }

        const models = [];

        for (const model of value) {

            models.push(model instanceof AddonSetting ? model : new AddonSetting(model));
        }

        return models;
    }

    getTypeLabel() {

        switch (this.type) {

            case this.constructor.TYPE_LIVE:

                return 'LIVE';

            case this.constructor.TYPE_TRIAL:

                return 'TRIAL';
        }
    }

    getStatusLabel() {

        switch (this.status) {

            case this.constructor.STATUS_CANCELLED:

                return 'CANCELLED';

            case this.constructor.STATUS_EXPIRED:

                return 'EXPIRED';

            case this.constructor.STATUS_FUTURE:

                return 'FUTURE';

            case this.constructor.STATUS_LIVE:

                return 'LIVE';

            case this.constructor.STATUS_NON_RENEWING:

                return 'NON_RENEWING';

            case this.constructor.STATUS_SUSPENDED:

                return 'SUSPENDED';

            case this.constructor.STATUS_TRIAL:

                return 'TRIAL';

            case this.constructor.STATUS_TRIAL_EXPIRED:

                return 'TRIAL_EXPIRED';

            case this.constructor.STATUS_UNPAID:

                return 'UNPAID';
        }
    }

    formatType() {

        return this.recurring_plan === this.constructor.RECURRING_PLAN_MONTHLY ? 'RP_MONTHLY' : 'RP_ANNUAL';
    }

    formatStatus() {

        return this.constructor.FORMATTED_STATUSES[this.status];
    }
}

AccessorsMutatorsDecorator('id', 'property', 'coupon', 'user', 'property_id', 'coupon_id', 'type', 'amount', 'activated_at', 'cancelled_at', 'created_at', 'old_status','old_id',
    'expiry_date', 'status', 'status_label', 'allow_to_cancel', 'trial_days', 'recurring_plan', 'sms_number', 'billing_information', 'payment_detail', 'addons', 'total_price',
    'total_price_with_vat', 'billing_cycle_date', 'next_billing_date', 'last_billed_date', 'start_date', 'end_date',
    'amount_due', 'discount_value', 'period_length', 'invoice_status', 'base_subscription_id', 'base_subscription', 'payment_integration_added_at', 'init_addon_list',
    'is_reactivation', 'billing_invoices'
)(Subscription);



// WEBPACK FOOTER //
// ./src/pms-api/models/subscription.model.js